import React, { Component } from 'react';
import './CheckboxFilter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckboxFilterOption from './CheckboxFilterOption';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class CheckboxFilter extends Component {
	constructor(props){
		super(props)
		const {onSelectionChange}=props;
		if(!onSelectionChange)throwNotProvided('onSelectionChange');
		this._onSelectionChange=onSelectionChange;
		this.getCheckedValues = this.getCheckedValues.bind(this);
		this.setOptions = this.setOptions.bind(this);
		this.clear = this.clear.bind(this);
		this.state = {entries:[]};
	}
	get isApplied(){
		const entries = this.state.entries;
		for(var i=0; i<entries.length; i++){
			let entry = entries[i];
			if(!entry.ref.current)continue;
			entry = entry.ref.current;
			if(entry.isChecked)
				return true;
		}
		return false;
	}
	getCheckboxOptions(){
		return this.state.entries;
	}
	setOptions(newOptions){
		const entries = this.state.entries;
		const mapValueStringToOption = new Map();
		newOptions.forEach((newOption)=>{
			mapValueStringToOption[newOption.valueString]=newOption;
		});
		const checkboxFilterOptionsToRemove =[];
		entries.forEach((existingCheckboxFilterOption)=>{
			const existingCheckboxFilterOptionValueString = existingCheckboxFilterOption.valueString;
			if(mapValueStringToOption.has(existingCheckboxFilterOptionValueString)){
				const option = mapValueStringToOption.get(existingCheckboxFilterOptionValueString);
				newOptions.splice(newOptions.indexOf(option), 1);
				return;
			}		
			checkboxFilterOptionsToRemove.push(existingCheckboxFilterOption);
		});
		for(var i=0; i<checkboxFilterOptionsToRemove.length; i++){
			const checkboxFilterOptionToRemove = checkboxFilterOptionsToRemove[i];
			entries.splice(entries.indexOf(checkboxFilterOptionToRemove), 1);
		}
		newOptions.forEach((newOption)=>{
			const checkboxFilterOption = (<CheckboxFilterOption key={newOption.valueString} ref={React.createRef()} option={newOption} onChange={this._onSelectionChange}></CheckboxFilterOption>);
			entries.push(checkboxFilterOption);
		});
		this.setState({entries:entries});
	}
	clear(){
		this.state.entries.forEach((entry)=>{
			entry.ref.current.clear();
		});
	}
	getCheckedValues(){
		const checkedValues=[];
		this.state.entries.forEach((entry)=>{
			if(!entry.ref.current)return;
			entry = entry.ref.current;
			if(entry.isChecked)
				checkedValues.push(entry.value);
		});
		return checkedValues;
	}
	render() {
		return (<div className="checkbox-filter">
				<div className="wrapper">
				{this.state.entries}
				</div>
			</div>)
	}
}
